export function subscriptionsEnabled(configs) {
  return configs.ENABLE_SUBSCRIPTIONS === "true" || configs.ENABLE_SUBSCRIPTIONS === true;
}

export function canEnterFromRoomSession(session) {
  if (!session) return true;

  return session.canEnter !== false;
}

export function canWaitInLobbyFromRoomSession(session, config = {}) {
  return !!session && !canEnterFromRoomSession(session) && config?.roomEntryDialog?.lookAround?.enabled !== false;
}

export function isReservedRoomSession(session) {
  return !!session && (session.state === "pending_active" || session.state === "lobby");
}

export function getRoomSessionForRoom(roomId, ...sessions) {
  if (!roomId) return null;
  return sessions.find(session => session && (session.roomId === roomId || session.hubId === roomId)) || null;
}
